var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2430_2400)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1298 19.7804C19.4498 20.0104 19.8698 20.0604 20.2398 19.9304C20.6098 19.7904 20.8798 19.4704 20.9598 19.0904C21.8298 15.0104 23.9398 4.67038 24.7298 0.950377C24.7898 0.670377 24.6898 0.380377 24.4698 0.190377C24.2498 0.000376686 23.9498 -0.0496233 23.6698 0.0503767C19.4798 1.60038 6.56984 6.45038 1.28984 8.40038C0.959839 8.52038 0.739839 8.85038 0.749839 9.20038C0.759839 9.55038 0.999839 9.86038 1.33984 9.96038C3.70984 10.6704 6.80984 11.6504 6.80984 11.6504C6.80984 11.6504 8.25984 16.0404 9.01984 18.2604C9.11984 18.5404 9.32984 18.7604 9.61984 18.8404C9.90984 18.9204 10.2198 18.8404 10.4298 18.6304C11.6498 17.4804 13.5298 15.7104 13.5298 15.7104C13.5298 15.7104 17.0998 18.3304 19.1298 19.7704V19.7804ZM8.11984 11.1004L9.79984 16.6404L10.1698 13.1304C10.1698 13.1304 16.6598 7.28038 20.3598 3.95038C20.4698 3.85038 20.4798 3.69038 20.3898 3.57038C20.2998 3.46038 20.1398 3.43038 20.0098 3.51038C15.7198 6.25038 8.11984 11.1104 8.11984 11.1104V11.1004Z",
    fill: "#188C7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2430_2400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramGreen);
export default __webpack_public_path__ + "static/media/telegram-green.2bb3679e0566067f8576ce8c400a5b60.svg";
export { ForwardRef as ReactComponent };